import { gql } from "urql";
export const QUERY_TEAM_MEMBERS = gql`
  query teamMembers {
    teamPage {
      data {
        attributes {
          team_members(pagination: { limit: 100 }) {
            data {
              attributes {
                name
                designation
                image {
                  data {
                    attributes {
                      name
                      alternativeText
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
